(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    /* Mobile navigation */
    var toggle = document.querySelector('.nav-toggle');
    var nav = document.getElementById('MainNav');
    if (toggle && nav) {
      toggle.addEventListener('click', function () {
        var open = nav.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    /* Product page: gallery thumbnails */
    var mainImg = document.getElementById('ProductMainImg');
    document.querySelectorAll('.product__thumbs button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!mainImg) return;
        mainImg.removeAttribute('srcset');
        mainImg.removeAttribute('sizes');
        mainImg.src = btn.getAttribute('data-full');
        mainImg.alt = btn.getAttribute('data-alt') || '';
      });
    });

    /* Product page: variant selector */
    var select = document.querySelector('[data-variant-select]');
    if (select) {
      var price = document.querySelector('[data-product-price]');
      var compare = document.querySelector('[data-product-compare]');
      var addBtn = document.querySelector('[data-add-button]');
      var addLabel = document.querySelector('[data-add-label]');

      var update = function () {
        var opt = select.options[select.selectedIndex];
        if (!opt) return;
        if (price) price.textContent = opt.getAttribute('data-price');
        if (compare) {
          var c = opt.getAttribute('data-compare');
          compare.textContent = c || '';
          compare.hidden = !c;
        }
        var available = opt.getAttribute('data-available') === 'true';
        if (addBtn) addBtn.disabled = !available;
        if (addLabel) addLabel.textContent = available ? 'Add to cart' : 'Sold out';
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', opt.value);
          window.history.replaceState({}, '', url.toString());
        }
      };
      select.addEventListener('change', update);
    }

    /* Collection sorting */
    var sort = document.querySelector('[data-sort-select]');
    if (sort) {
      sort.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }
  });
})();
